import images from './images.js'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import utils from './utils.js'

class PhotoGallery {

    constructor(gid) {
        this.GID = gid
    }
    
    loadGallery = (pid) => {

        const pswpElement = document.querySelectorAll('.pswp')[0]
        var index
        
        //convert pid string to pid index if necessary:
        if (!Number.isInteger(parseInt(pid))) {
            index = images.findIndex(o => o.pid === pid);
            if (index === -1) return false
        } else {
            //but index must be in range:
            if (pid > images.length - 1) return false
            index = parseInt(pid)
        }
        
        const options = {
            index: index,
            history: true,
            galleryPIDs: true
        }
        
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, options);
        this.gallery.listen('close', function () {
        })
        this.gallery.listen('destroy', function () {
            this.gallery = null;
        })

        this.gallery.listen('afterChange', function () {           
            this.sendAnalyticsEvent()
        }.bind(this))

        this.gallery.init()
        return true
    }

    randomGalleryPic = () => {
        const range = images.length
        const index = utils.getRandomInt(0, range)
        this.loadGallery(index)
    }

    sendAnalyticsEvent = () => {
        let pid = this.gallery.currItem.pid
        console.log("Event:"+pid)
        window.ga('send', {
            hitType: 'event',
            eventCategory: 'Gallery',
            eventAction: 'view',
            eventLabel: pid
          });
    }
}
export default PhotoGallery